export const DateFormats = {
  extendedFormat: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  },
  extendedDateTimeFormat: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  },
  lessExtendedDateTimeFormat: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  },
  defaultDateTimeFormat: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  },
  defaultDateFormat: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  },
  monthDayYear: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }
}
